var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSmall = function SvgStarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#902EEF",
    d: "M13.64 1.815c.665-1.688 3.055-1.688 3.72 0l3.054 7.742a2 2 0 0 0 1.127 1.127l7.741 3.053c1.689.666 1.689 3.055 0 3.721l-7.741 3.054a2 2 0 0 0-1.127 1.126L17.36 29.38c-.665 1.689-3.055 1.689-3.72 0l-3.054-7.742a2 2 0 0 0-1.127-1.126l-7.742-3.054c-1.688-.666-1.688-3.055 0-3.72l7.742-3.054a2 2 0 0 0 1.127-1.127z"
  })));
};
export default SvgStarSmall;